export default __webpack_public_path__ + "static/media/home-design-agency-img-08.2eb5ec62.jpg";